<template>
  <Tag unstyled
    class="   px-2 py-1 rounded-full text-sm font-medium"
    :class="isLink ? 'bg-[#634fab] text-[#f3f1f9] dark:bg-[linear-gradient(92.4deg, #7d5ca1 6.22%, #9d73c7 93.78%)]': 'bg-[#f3f1f9] text-[#634fab] dark:bg-[linear-gradient(92.4deg,_#270945_6.22%,_#4C127F_93.78%)] dark:text-white'"
    >
    <slot>
      {{ tag }}
    </slot>
  </Tag>
</template>

<script setup lang="ts">
const Tag = defineAsyncComponent(() => import('primevue/tag'))

const props = withDefaults(defineProps<{
  tag?: string | object;
  isLink?: boolean;
}>(), {
  tag: "div",
  isLink: false
});
</script>
